import { Injectable } from '@angular/core';
import { LoggerService } from '../../telemetry/logger.service';
import { StoredCachedService } from '../../driver/storage/models/stored-cached-service';
import { indexedDb } from 'src/app/dexie/indexed-db-data-store';
import { BaseRepository } from '../../repository/base.repository';

/**
 * Provides access to and management of cached services from the server.
 * Handles storage, retrieval, and updates of cached services for optimized access.
 * Extends the BaseRepository class to provide a specific implementation for cached services.
 *
 * **THIS REPOSITORY HAS A CACHE LAYER**
 * **Direct access to the this class should not be used. All requests should go through @see {CachedServiceRepositoryCacheManager}**
 */
@Injectable({
	providedIn: 'root'
})
export class CachedServicesRepository extends BaseRepository<StoredCachedService> {
	/**
	 * @constructor
	 *
	 * @param logger The logging service.
	 */
	constructor(
		logger: LoggerService
	) {
		super(indexedDb.CachedServices, logger);
	}
}